export default __webpack_public_path__ + "static/google-scholar-logo-e934ad06c93211301183fe50f03f13b1.svg";